import React from 'react'

const Loader = () => {
  return (
    <img className='mx-auto d-block' src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Loader.gif/480px-Loader.gif" alt='loader'/>
  )
}

export default Loader